const initialReports = {
    reports: [],
    customerreports : [],
    attendancereports : [],
    ledgerreports : [],
    daybookreports : [],
    locationreports : [],
    paymentreports : [],
    orderreports : [],
    targetreports : [],
    punchinreports : [],
    stockreports : [],
    dailyentriesreports : [],
    expensereports : [],
    brandwisereports : [],
    pendingpurchaseorderreports : [],
    bometricreports : [],
    deliveryreports : []
};

const ReportsReducer = (report = initialReports, action) => {
    switch (action.type) {
        case "GET_REPORTS":
            return {
                ...report, reports: action.payload.data
            };
        case "GET_LOCATION_REPORTS":
            return {
                ...report, locationreports: action.payload.data
            };
        case "GET_PAYMENT_REPORTS":
            return {
                ...report, paymentreports: action.payload.data
            };    
        case "GET_ORDER_REPORTS":
            return {
                ...report, orderreports: action.payload.data
            };        
        case "GET_CUSTOMER_REPORTS":
            return {
                ...report, customerreports: action.payload.data
            };
        case "GET_ATTENDANCE_REPORTS":
            return {
                ...report, attendancereports: action.payload.data
            };
        case "GET_LEDGER_REPORTS":
            return {
                ...report, ledgerreports: action.payload.data
            };  
        case "GET_DAYBOOK_REPORTS":
            return {
                ...report, daybookreports: action.payload.data
            };  
        case "GET_TARGET_REPORTS":
            return {
                ...report, targetreports: action.payload.data
            };  
        case "GET_PUNCHIN_REPORTS":
            return {
                ...report, punchinreports: action.payload.data
            };      
        case "GET_STOCK_REPORTS":
            return {
                ...report, stockreports: action.payload.data
            };  
        case "GET_DAILY_ENTRIES_REPORTS":
            return {
                ...report, dailyentriesreports : action.payload.data
            };  
        case "GET_EXPENSE_REPORTS":
            return {
                ...report, expensereports : action.payload.data
            }; 
        case "GET_BRANDWISE_REPORTS":
            return {
                ...report, brandwisereports : action.payload.data
            }; 
        case "GET_PURCHASEORDERPENDING_REPORT":
            return{
                ...report, pendingpurchaseorderreports : action.payload.data
            };
        case "GET_BIOMETRIC_REPORT":
            return{
                ...report, bometricreports : action.payload.data
            };
        case "GET_DELIVERY_REPORT":
            return{
                ...report, deliveryreports : action.payload.data
            };
        default:
            return report;
    }
}
export default ReportsReducer;